"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// strategies from from https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
exports.fullJitter = function (_a) {
    var retryAttempt = _a.retryAttempt, _b = _a.maxDelayMs, maxDelayMs = _b === void 0 ? 10000 : _b, _c = _a.seedDelayMs, seedDelayMs = _c === void 0 ? 1000 : _c;
    var unjitteredWait = Math.min(maxDelayMs, seedDelayMs * Math.pow(2, retryAttempt));
    return Math.random() * unjitteredWait;
};
exports.equalJitter = function (_a) {
    var retryAttempt = _a.retryAttempt, _b = _a.maxDelayMs, maxDelayMs = _b === void 0 ? 10000 : _b, _c = _a.seedDelayMs, seedDelayMs = _c === void 0 ? 1000 : _c;
    var unjitteredWait = Math.min(maxDelayMs, seedDelayMs * Math.pow(2, retryAttempt));
    var baseWait = unjitteredWait / 2;
    return baseWait + Math.random() * baseWait;
};
